import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

const TwoColumnGrid = ({ items }) => {
  const rows = [];
  for (let i = 0; i < items.length; i += 2) {
    rows.push([items[i], items[i + 1]]);
  }

  return (
    <div>
      {rows.map((pair, rIdx) => (
        <Row key={rIdx} className="mb-2">
          {pair.map((it, cIdx) => {
            if (!it) return <Col key={cIdx} />;
            const shouldHighlight = it.highlight && Number(it.raw) && Number(it.raw) !== 0;
            return (
              <Col key={cIdx} xs={6} className="ps-0">
                <div className="small text-muted">{it.label}</div>
                <div className={`fw-semibold ${shouldHighlight ? 'text-danger' : ''}`}>{it.value || '-'}</div>
              </Col>
            );
          })}
        </Row>
      ))}
    </div>
  );
};

TwoColumnGrid.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      raw: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      highlight: PropTypes.bool
    })
  ).isRequired
};

export default TwoColumnGrid;
